import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '../ui/button';

export default function LogoutButton() {
	const { logout, isLoading } = useAuth0();

	return (
		<Button
			className="min-w-20"
			variant="secondary"
			isLoading={isLoading}
			onClick={() =>
				logout({
					logoutParams: {
						returnTo: window.location.origin
					}
				})
			}
		>
			Log Out
		</Button>
	);
}
